/**
 * Shared CRM follow-up resolution for lead list, detail, and exports.
 * Only Active follow-ups carry a next follow-up date.
 * Closed Lost / Deal Dropped leave Inactive rows — never fall back to those for dates.
 */

export function resolveActiveFollowUp(followUps = []) {
  if (!Array.isArray(followUps) || followUps.length === 0) {
    return null;
  }
  return followUps.find((f) => f?.status === 'Active') ?? null;
}

/**
 * @deprecated Qualification saves sync into the Active follow-up record.
 * Keep CRM Active date as the single display source so list and detail match.
 */
export function resolveEffectiveFollowUpDate(activeFollowUp, _qualificationFollowUpAt = null) {
  return activeFollowUp?.nextFollowUpDate ?? null;
}

export function getNextFollowUpForLead(followUps = [], qualificationFollowUpAt = null) {
  const activeFollowUp = resolveActiveFollowUp(followUps);
  const date = resolveEffectiveFollowUpDate(activeFollowUp, qualificationFollowUpAt);
  const agenda = activeFollowUp?.agenda?.trim() || null;

  return {
    date,
    agenda,
    followUp: activeFollowUp
  };
}
